module.exports = __webpack_public_path__ + "static/web_detect directionality.3a133c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/web_detect directionality.png
// module id = 718
// module chunks = 154382131621592